/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCornerRightDownDouble = createReactComponent("outline", "corner-right-down-double", "IconCornerRightDownDouble", [["path", { "d": "M5 4h6a3 3 0 0 1 3 3v7", "key": "svg-0" }], ["path", { "d": "M10 10l4 4l4 -4m-8 5l4 4l4 -4", "key": "svg-1" }]]);

export { IconCornerRightDownDouble as default };
//# sourceMappingURL=IconCornerRightDownDouble.mjs.map
